import { useOrgIntegrationConnections } from "@/api/integrations";
import { hasPlatformEntitySelector } from "@/constants/integration-platforms";
import { useMemo } from "react";

export function useSelectableIntegrationConnections() {
  const {
    data: integrationConnections = [],
    isPending,
    isError,
  } = useOrgIntegrationConnections();

  const connections = useMemo(
    () =>
      integrationConnections
        .filter((connection) =>
          hasPlatformEntitySelector(connection.integration_platform),
        )
        .sort((a, b) => a.integration_name.localeCompare(b.integration_name)),
    [integrationConnections],
  );

  return { connections, isPending, isError };
}
